var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IConfigurationRepositoryType } from '../../../Domain/UseCases/Configuration/IConfigurationRepository';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { IEventsDataSourceType } from '../../DataSource/EventsDataSource/IEventsDataSource';
import { inject } from '../../Decorators/Inject';
import { injectable } from '../../Decorators/Injectable';
import { CoreConfig } from '../../../CoreConfig';
import { parseNumberToString } from '../../../Helpers/ParseNumberToString/ParseNumberToString';
let DebugRepository = class DebugRepository {
    constructor(configurationRepository, apiDataSource, eventsDataSource) {
        this.configurationRepository = configurationRepository;
        this.apiDataSource = apiDataSource;
        this.eventsDataSource = eventsDataSource;
        this.debug = false;
        this.configurationRepository.configuration.observe(this, configuration => {
            var _a, _b;
            this.debug = !!((_b = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.debug);
            this.send({
                type: 'configuration',
                data: { configuration }
            });
        });
        this.apiDataSource.debugMessages.observe(this, value => {
            this.send(value);
        });
    }
    send(data) {
        if (!this.debug) {
            return data;
        }
        const event = {
            module: CoreConfig.moduleName,
            event: 'log',
            data: parseNumberToString(data)
        };
        this.eventsDataSource.sendEvent(CoreConfig.moduleName, event);
        return data;
    }
};
DebugRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IConfigurationRepositoryType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __param(2, inject(IEventsDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object])
], DebugRepository);
export { DebugRepository };
